import React, { useState } from 'react';
import "./TarikBetekrstyanDetails.css"
import ImageOne from "../assets/shalom-front.jpg";
import ImageTwo from "../assets/kampala-uganda.jpg";
import ImageThree from "../assets/vision-church.jpg";
import ImageFour from "../assets/singers-together.jpg";
import ImageFive from "../assets/building-blessing.jpg";
import ImageSix from "../assets/logo.png";
import Slideshow from "./Slideshow.js"
import {AiOutlineMinus, AiOutlinePlus} from "react-icons/ai";

const TarikBetekrstyanDetails = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const [click1, setClick1] = useState(false);
  const handleClick1 = () => setClick1(!click1);

  return (
    <div className='main-container'>
      <div className='tarik-cotainer'>
        <h1>ሓጺር ታሪኽ ሻሎም ወሓዚ ህይወት ቤተክርስትያን ካምፓላ ኡጋንዳ</h1>
        <div className='img-container'>
            <img className="image-1 img-all"
              src={ImageOne} alt="Shalom-Front" />
              <span>ህንጻ ሻሎም ወሓዚ ህይወት ቤ/ክ ኡጋንዳ</span>
        </div>
        <p>
        ኡጋንዳ ኣብ ምብራቅ ኣፍሪቃ እትርከብ  ምስ ደቡብ ስዳን፡ ኬንያ ፡ኮንጎ፡ርዋንዳን ታንዛንያን እትዳወብ ብቀላይ ኤድዋርድ ቀላይ ኣልበርት ቀላይ ቪክቶርያ እተከበብት ልዕሊ 43 ሚልዮን ህዝቡ ዝነብርዎ ሃገር እያ። ህዝቢ ኡጋንዳ ብዘለዎም ናይ እምነት ነጻነት ኣብ ምስፋሕ መንግስቲ ኣምላኽ ዓቢ ኣበርክቶ ገይሩ እዩ: ከም መርኣያ ድማ ልዕሊ 45 ሚእታዊት ካብ ህዝባ ዳግም እተወልዱ ክርስትያናት ምኻኖት ይፍለጥ። ሻሎም ወሓዚ ህይወት ቤተክርስትያን እምበኣር  ኣብዚ ናይ እምነት ነጻነት ዘለዎ ሃገር ኡጋንዳ ኣብ ርእሲ ከተማ ካምፓላ ተደዀና ትርከብ። ኩልና ከምንፈልጦ ህዝብና ናብ ስደት ዘምርሓሉ ዝነበረ ግዜ ምኻኑ እዩ ፡ መንግስቲ ኡጋንዳ ነቲ ንስደተኛታት ዘለዎ ዝምስገን ልቢ ንህዝብና ከዕርፎ ተራእዩ።እምበኣር እዞም ብስደት ኣብ ኡጋንዳ ዝመጹ ኣመንቲ ክርስትና ኣምላኽ ብጥበቡ ዝፋለጥሉን ዝሓብርሉን ደገ ስለ ዝኸፈተ ዚ ኩሉ ክኸውን ከሎ ንርእዮ ኣሎና።
        </p>
        <div className='img-container'>
            <img className="image-2 img-all"
              src={ImageTwo} alt="Kampala-Uganda" />
              <span>ካምፓላ ርእሰ ከተማ ኡጋንዳ</span>
        </div>
        <p>
        ብኣዝዩ ውሑድ ቁጽሪ ብዕለት <span className='bold-underline'>02/05/2004 ዓ/ም</span> ናኩላቢ ኣብ ዝበሃል ቦታ ኣብ ቤት <span className='bold-underline'>ሓፍትና ትርሓስ ተወልደ “ጸልዩን ንኤርትራ’’</span> ኣብ ትሕቲ ዝብል ቴማ ናይ ሕብረት ጸሎት ተጀሚሩ።ኣብቲ እዋን እቲ ሓንቲ ብኣምሓርኛ እተገልግል “ራእይ እግዚኣብሄር” እትበሃል ቤተክርስትያን ጥራይ እያ ነይራ (ብዘይካ እዛ እተጠቕሰት ቤተክርስትያን ብትግርኛ ይኹን ብኣምሓርኛ ዝግልገል ኣገልግሎት ኣይነበረን)።
        </p>
        <p>
        እግዚኣብሄር ድማ ነዚ ናይ ጸሎት ጉጅለ እናዕበዮ ስለዝኸደ ኣብ ገዛ እንዳ ዳንኤል ሓጎስ (ሕጂ ኣብ ኣመሪካ)ዘሎ ዕዮና ቀጸልና።    ቑጽሪ ጸለይቲ ኣዝዩ ስለዝወሰኸ  ምስ ምግፋሕ እዛ ከተማ ብመንጽር ኣቀማምጣናን ዳግመ ግምት ተግይርሉ ዕዮና ብምዝርጋሕ እንዳ ሓውና ባህታ ተስፋይ ናኩላቢ፡ሓው የውሃንስ ሃይለ ካቦዋ፡ነፍስሄር ፍስሃ ኣብርሃ (በዓል ቤታ ንኣልማዝ ኣጽብሃ) ካንሳንጋ፡ ኣብዘን ኣባይቲ እዚኤን ጸሎት ቀጸልና። እግዚኣብሄር ፍቅሩን ረድኤቱን በዚሑልና መንግስቲ ኣምላኽ ብናህሪ ክትዓብን ክትሰፍሕን ጀሚራ። ብኡ መጠን ድማ መንፈሳዊ ህይወትና ተነቃቅሐ ፡ኣገልግሎትናውን ብፍቅርን ብጸጋን ዓበየ። ብብዞባኡ መንፈሳዊ ኣገልግሎት ሰሪዕና ኩሉ ግዜ ሰንበት ጸሎትን ቃል ኣምላኽን ኣምልኾን፡ ዓርቢ ድማ ሓዳሪ ጸሎት፡ ኣብ ክልተ ወርሒ ሓንሳብ ከኣ ምሉእ መዓልቲ ጾምን ጸሎትን፡ ከምኡ`ውን ተወሳኺ ሰንሰለታዊ ናይ ጸሎት ግዜ ነይሩና። እቶም ናይ ጸሎት መራሕቲ ኣብ ሰሙን ሓደ ግዜ እናተራኸብና ንጽልየሉን ንዘራረበሉን ኣብ ዝነበርናሉ ግዜ እግዚኣብሄር፡ 
        </p>
        <div className='expand-verse' onClick={handleClick}>
          {click ? (
            <div className='verse'>
              <div className='verse-ref'>
                <AiOutlineMinus size={20} style={{color: "#61ce70"}} /> 
                <span style={{color: "#61ce70"}}>ሉቃ12፡3</span>
              </div>              
              <hr />
              <p className='bold-verse'>
              ኣታ ሒደት መጓሰ እታ መንግስቲ ኽህበኩም ፍቓድ ኣቦኹም እዩ እሞ ኣይትፍርህ” ብምባል ሓሳቡ ኣብ ልቢ ነፍሲ ወከፍ ሰብ ኣፍሰሰ።
              </p>
            </div>        
          ) : (
            <div className='verse-ref'>
              <AiOutlinePlus size={20} style={{color: "#6ec1e4"}} />
              <span style={{color: "#6ec1e4"}}>ሉቃ12፡3</span>
            </div>
          )}             
        </div>
        <p>
        በዚ እተዋህበና ቃል ንነዊሕ እዋን ብምጽላይን ገጽ እግዚኣብሄር ብምድላይን ሓሳብ ኣምላኽ ኣብ ሕብረትና ክንርዳእ ክኢልና።
        </p>
        <div className='goal-list'>
          <p>
          ብመንፈስ ኣምላኽ ተመሪሕና ከኣ ብኸምዚ ዝስዕብ ኣብ ጽሑፍ ኣስፊርናዮ
          </p>
          <ol>
            <li>ንዝመጽእ ዘመን ብቁዕ ወለዶ ምድላው</li>
            <li>ካብ ጸጋ ጐዲሉ ንዝደኸመ ምንቅቃሕን ምሕቃፍን</li>
            <li>ዝመጹ ኣገልገልቲ ጸግኦም ንኽንጥቀመሉ ደገ ኣገልግሎት ምኽፋት</li>
            <li>ህዝብና ብዝርድኦ ቋንቃ(ብትግርኛ)ንጐይታ ዘምልኽሉን ዘገልግልሉን ባይታ ምፍጣር</li>
            <li>ብወንጌል ንኹሉ ፍጡር ምብጻሕን ወንጌል ዘይበጽሖ ብኣኻል ብምኻድ ምምስካር</li>
            <li>ናብ እተፈላለየ ኩርንዓት ዓለም ዝኸይድ ምእመን ኣብ ዝኸዶ ሕብረተሰብ ክርስቶሳዊ ጽልዋ ክህልዎን መንግስቲ ኣምላኽ ከስፍሕን ከንጸባርቅን ሓይልን ፍልጠትን ምስናቕ ዝብል እዩ።</li>
          </ol>        
        </div>
        <p>
        ናይ ሓድሽ ኪዳን ራእይ ግሉጽ ምኻኑ ብምርዳእ ጻውዒትና ብምስትውዓል ጸልዩ ንኤርትራ ካብ ዝብል ስም ብደሙ ዝዓደጋ ማሕበር ክርስቶስ ቅድሚ ምኽፋትና ጐይታ ብባሮቱ ከምዚ ኢሉ ፡
        </p>

        <div className='expand-verse' onClick={handleClick1}>
          {click1 ? (
            <div className='verse'>
              <div className='verse-ref'>
                <AiOutlineMinus size={20} style={{color: "#61ce70"}} /> 
                <span style={{color: "#61ce70"}}>ህዝ 47፡9</span>
              </div>              
              <hr />
              <p className='bold-verse'>
              ኪኸውን ድማ እዩ፡ ኣብቲ እዚ ውሒዝ እዚ ዝበጽሖ ዘበለስ ኲሉ ዚዋሳወስ ህያው ነፍሲ ብህይወት ኪነብር እዩ፡ ዓሳ ኸኣ ኣዝዮም ኪበዝሑ እዮም። እዚ ማያት እዚ ኺኣትዎ እዩ እሞ፡ እቲ ማያት ባሕሪ ኺጥዒ እዩ። እቲ ውሒዝ ኣብ ዝኣተዎ ዘበለ ድማ ኲሉ ብህይወት ኪነብር እዩ።
              </p>
            </div>        
          ) : (
            <div className='verse-ref'>
              <AiOutlinePlus size={20} style={{color: "#6ec1e4"}} />
              <span style={{color: "#6ec1e4"}}>ህዝ 47፡9</span>
            </div>
          )}             
        </div>
        
        <div className='img-container'>
            <img className="image-3 img-all"
              src={ImageThree} alt="vision-church" />
              <span>ሻሎም ወሓዚ ህይወት ቤ/ክ ኣብ ህንጻ ራእይ እግዚኣብሄር ቤተክርስትያን እንከላ</span>
        </div>
        <p>
        ጐይታ ንልብና ዝያዳ ኣጽኒዕዋን ኣበርቲዕዎን እዩ። እንታይ ክንገብር ከም ዘሎና ብምዝርራብ ንራእይ እግዚኣብሄር ቤተክርስትያን (ናይ ኣምሓርኛ) ንመራሕቲ ራእይናን ጻውዒትና ንህዝብና ብቛንቁኡ ንምግልጋል ዘሎና ራእይ ኣብ ታሕሳስ 3-2005 ዓ/ም ብጽሑፍ ኣቕረብናሎም። ንሳቶም ድማ ዓደሙና እሞ ጽቡቅ ናይ ጸሎትን ምዝርራብን ግዜ ጌበርና፡ ኣብ ካልኣይ ግዜ ርክብና ሓቢርና ናይ እግዚኣብሄር መንግስቲ ከነስፍሕን ክንዓይን ምኻንና ብምርዳእ፡  ብፍቅሪ ብናይ በረኸት ጸሎት የማናይ ኢዶም ሂቦም ኣፋነውና ፡ክሳብ ሕጂ እውን ከም ኣሓት ኣብያተ ክርስትያናት ጽቡቅ ሕውነት ኣሎና።ከም መርኣያ ድማ 2012 ብምኽንያት ስፍሓት ኣገልግሎት KPC ጽበት ቦታ መገልገሊ ሽለዠግእተምዕም፡ ካብ KPC ክንወጽእ ከሎና ራእይ እግዚኣብሄር ቤተክርስትያን  ካብ (2012-2016) 4 ዓመት ኣዳራሽ ቤተክርስትያኖም ሰንበት ሰዓት 2፡30ድ/ቀ ክንጥቀመሉ ፈቀዱልና መርዓን ካልእ መደብ ምስዝህልወን እውን ብነጻነት ብዘይ ስክፍታ ተጠቂምናሉ ስም ኣምላኽ ይባረኽ።
        </p>
        <p>
        ድሕርዚ ብደረጃ ሕብረት ንሓደ ሰሙን ምሉእ ናይ ጾምን ጸሎትን ግዜ ብምምዳብ ኣብ መወዳእታ መዓልቲ ናይቲ መደብ ኣብ ማእከልና ካብ 25-30 ኣሕዋት ኣባላት ሕብረት እተረኽብሉ ብኣቦ መንበር ሓውና ኣማኑኤል ተስፋይ (ሕጂ ኣብ ካናዳ ዘሎ) ምምስራት ቤተክርስትያን ብወግዒ ተኣዊጁ።
        </p>
        <div className='img-container'>
            <img className="image-4 img-all"
              src={ImageFour} alt="singers-all" />
              <span>ናይ ኣብያተ ክርስትያናት መዘምራን ብሕብረት ኮንፈረንስ ኣብ ራእይ እግዚኣብሄር ቤተክርስትያን 2012</span>
        </div>
        <p>
        ሻሎም ወሓዚ ህይወት ቤተክርስትያን  ተብሂላ ክትስመ ብዕለት 27 ሕዳር 2005 ንምጀመርያ ግዜ ብደረጃ ማሕበር ናይ ትግርኛ ኣገልግሎት ኣብ ካላንደር ሆቴል ብወግዒ ተጀሚሩ።
        </p>
        <p>
        ኣብዚ ፈለማ ምምስራት ቤተክርስትያን ዝነበሩ ኣገልገልቲ ረቨረንድ ተመስገን ፍስሃየ ካብ ኣመሪካ ከምኡውን ጓሳ ማሕበር ኣሮን ተስፋይ ካብ ዱባይ ብቃልን ብምትብባዕን ብፍሉይ ጸጋ ኣገልጊለሙና ።እዚ መደብ ንሰለስተ ሰሙን ዝቀጸለ እዩ ነይሩ። ብድሕሪ ኣዚ ናብ KPC(KAMPALA PENTECOSTAL CHURCH) ናይ ሕጂ WATOTOO ብምኻድ ራእይናን ጻውዒትናን ምስ ነገርናዮም መኣከቢ ኣዳራሽ ብምሃብ ኣብ ትሕቲ  ጽላል KPC ኵይና ከነገልግል ፈቀዱልና።እዚ ቦታ ንመጐዓዝያ ምቹእ ኣብ ርእሲ ምኻኑ  ኣምላኽ ኣብ ልቢ እዞሞ መራሕቲ ፍሉይ መጎስ ስለ ዝሃበና ኣብ ኩሉ ዕዮና ብዝደለናዮም የማናይ ኢዶም ብምሃብ ልዑል ፍቅሪ ስለ ዘርኣዩና  ዕዮና ብናህሪ ክጐይይ ሓጊዙና እዩ።
        </p>
        <p>
        ሻሎም ወሓዚ ህይወት ቤተክርስትያን ንሓደ ዓመት ዝኣኽል ብሽማግላዊ ኣመራርሓ ክትምራሕ ድሕሪ ምጽናሕ ዕዮ ጐይታ ዝያዳ ክሰፍሕን ከድምዕን ብምባል ብምሉእ ፍቃድ ኣባላት ናብ ጉስነታዊ  ምሕደራ(pastoral leadership)  መጀመርያ 2007 ተሰጋጊራ።ፓስቶር እስቲፋኖስ መንግስተኣብ ጓሳ ማሕበር ክኸውን ተሸይሙ።ጉባኤ ማሕበር ብምሉእ ድምጺ ብምስምማዕ  ቅዋም ጸዲቁ።መሪሕነት  መሳልል ተገይርሉ ብጽፉፍ ተሓታትነ ብዘለዎ መንገዲ ክቅጽል ጀሚሩ።
        </p>
        <p>
        እዚ ቅዋም እዚ ብድሕሪኡ መምስ ግዚኡ ዝጠልቦ ነገራት ክህሉ ንቡር ስለዝኾነ ኣብ 2013ን መሊሱ ውን ኣብ 2017  ምትዕርራይ ተግይርሉ ብምሉእ ድምጺ ተጋባእቲ ጸዲቁ።
        </p>
        <div className='img-container'>
            <img className="image-5 img-all"
              src={ImageFive} alt="blessing-new-hall" />
              <span>ኣብ ምዉፋይ ሓድሽ ህንጻ ሻሎም ወሓዚ ህይወት ቤ/ክ ዝተወስደ ስእሊ 2016</span>
        </div>
        <p>
        እዛ ዕሸል ማሕበር ኣብዚ እዋን እዚ ክሳብ 450 ዝኣኽሉ መእመን ዘለውዋ ናይ ገዛእ ርእሳ ህንጻ እትውንን ከይና ትርከብ።እዚ ህንጻ ንምስራሕ ብ2011 ብወግዒ ድሕሪ ምእዋጁ ገንዘብ ክዋጻእ እካ እንተጀመረ ምስቲ እዚ ህንጻ ክስራሕ ዘድልዮ ወጻኢ ኣዝዩ ውሑድ ነበረ ። ካብዚ ተበጊስካ እምበኣር እዚ ህንጻ ማእለያ ዘይብሉ ገንዘቦም ኣብዚ ዕዮ ዘፍሰሱ ፍቃደኛ ዓየይቲ ኣሕዋት ዘዋስአ ምንባሩ ምግማት ከቢድ ኣይኮነን፡ በኣርባዕተ ወርሒ ተሃኒጹ ምስ ተወድአ ፡ መስረትቲ ቤተክርስትያን፡ዕዱማት ኣገልገልቲ፡ ኣገልገልቲ ኣብ ከባቢና ናይ ዘለዋ ኣሓት ኣብያተ-ክርስትያናትን፡ ዕዱማት ኣጋይሽን ፈተውትን ኣብ እተረኽብሉ መበል 11 ዓመት ምምስራት ቤተክርትያንን ምምራቅ ህንጻ ሻሎም ወሓዚ ህይወት ቢተክርስትያን ብዕለት 4/12/2016 ብክብ ዝበለ ኣገባብ ተጸንቢሉ። ነቲ ብዙሕ ግብሪ እግዚኣብሄር ዝርኣዩ ተኣምራታዊ ህንጻ ክሳዕ ዝብልዎ ምሕረት ኣምላክ ዝረኣናሉ ሓውልቲ ኮይኑ ይነብረ ኣሎ  ።ሻሎም ወሓዚ ህይወት ቤተክርስትያን ኣጀማምርኣ እዃ ንእሽተይ እንተመስለ ሕጂ ንብዙሓት መጽለሊት ኮይና ትርከብ፡ማእለያ ዘይብሉ ህዝቢ በዚ ክሓልፋን ክምርዓውን ምርኣይ ንቡር ተርእዮ ክሳዕ ዝኸውን መዕረፊ ኮይና ኣላ።
        </p>
        <div className='slide-show'>
          <p>
          መስርሕ ህንጻ ሻሎም ወሓዚ ህይወት ቤ/ክ ካብ መሰረት ክሳዕ መፈጸምታ ዝነበረ ገለ ካብ ሰነዳት
          </p>                       
        </div>
        <div className='slides'>
             <Slideshow />
          </div>  
        <p>
        እዚ ኩሉ ከም ታሪኽ እተሰነደ ሓቂ ሕጂ ድሕሪ ነዊሕ ግዜ ክንርእዮ ከሎና ናይ ብሓቂ ህይወት ለቢሱ ጎይታ ከምቲ ዝበሎ ህዝብና ኣብ ዝኸዶ ክርስቶሳዊ ጽልዋ ከምጽእ ምኽኣሉ ዘሓጉስ ተስፋ ዝመልእ ተርእዮ እዩ። ናይ ሻሎም ወሓዚ ህይወት ቤተክርስትያን ሎጎ(LOGO) ኣብዚ ጥቅሲ እተመርኮሰ እዩ።
        </p>
        <div className='expand-verse' onClick={handleClick1}>
          {click1 ? (
            <div className='verse'>
              <div className='verse-ref'>
                <AiOutlineMinus size={20} style={{color: "#61ce70"}} /> 
                <span style={{color: "#61ce70"}}>ህዝ 47፡9</span>
              </div>              
              <hr />
              <p className='bold-verse'>
              ኪኸውን ድማ እዩ፡ ኣብቲ እዚ ውሒዝ እዚ ዝበጽሖ ዘበለስ ኲሉ ዚዋሳወስ ህያው ነፍሲ ብህይወት ኪነብር እዩ፡ ዓሳ ኸኣ ኣዝዮም ኪበዝሑ እዮም። እዚ ማያት እዚ ኺኣትዎ እዩ እሞ፡ እቲ ማያት ባሕሪ ኺጥዒ እዩ። እቲ ውሒዝ ኣብ ዝኣተዎ ዘበለ ድማ ኲሉ ብህይወት ኪነብር እዩ።
              </p>
            </div>        
          ) : (
            <div className='verse-ref'>
              <AiOutlinePlus size={20} style={{color: "#6ec1e4"}} />
              <span style={{color: "#6ec1e4"}}>ህዝ 47፡9</span>
            </div>
          )}             
        </div>
        <div className='img-container'>
            <img className="image-logo"
              src={ImageSix} alt="logo" />
              <span>ናይ ሻሎም ወሓዚ ህይወት ቤ/ክ ሎጎ (Logo)</span>
        </div>
        <div className='shalom-places'>
          <p className='bold-title'>
          ሻሎም ወሓዚ ህይወት ቤተክርስትያን ካብ ትምስረት እተጠቅመትሎም ቦታታት
          </p>
          <ol>
            <li>ሻሎም ወሓዚ ህይወት ቤተክርስትያን ኣብ 2005 ኣብ ካላንደር ሆቴል ምስ ተመስረተት ብድሕሪኡ ፡ </li>
            <li>ካብ 2005-2012  ኣብ ትሕቲ ጽላል KPC</li>
            <li>ካብ 2012-2016 ህንጻ ራእይ እግዚኣብሄር ቤተክርስትያን</li>
            <li>ካብ 2016-ኣብ ህንጻ ሻሎም ወሓዚ ህይወት ቤተክርስትያን</li>
          </ol>
        </div>
        <div className='shalom-places'>
          <p className='bold-title'>
          ብብእዋኑ ብጉስነት ዘገልገሉ ኣገልገልቲ ሻሎም ወሓዚ ህይወት ቤተክርትያን
          </p>
          <ol>
            <li>ኣገልጋሊ ኣማኑኤል ተስፋይ ካብ 27/11/2005-2007 ዓ/ም(ኣቦ መንበር መሪሕነት ቅድሚ ናብ ጉስነታዊ ምህደራ ምስግጋሩ)</li>
            <li>ፓስቶር እስቲፋኖስ መንግስተኣብ ካብ 2007 -2011</li>
            <li>ፓስቶር ኪሮስ ተስፋይ   ካብ  2011-2013</li>
            <li>ፓስቶር ኣስመሮም ገብረገርግሽ(ኤልያስ)  ካብ 2013 ክሳብ ሕጂ</li>
          </ol>
        </div>
        
        <div className='final-notice'>
          <h4>ስም ኣምላኽ ንዘለኣለም ይባረኽ!</h4>
          <div className='blue-bg'>
            <span>ኣገዳሲ ሓበሬታ</span>
            <p>
            ሻሎም ወሓዚ ህይወት ቤተክርስትያን ካምፓላ ኡጋንዳ ካብ ጻላል ዝኮነ ኣካል ነጻ ዝኾነት መኽሰብ ኣብ ምግባር ዘተኮረ ኣገልግሎት ዘይብላ ማሐበር እያ። እዛ ማሕበር ነቶም ዘይደሓኑ ክድሕኑ፡ እቶም ዝደሓኑ ድማ ደቀ-መዝሙር ክርስቶስ ብምግባር ነቲ ግብሪ ኣገልግሎት ብቁዓት ክኾኑ ብኩሉ ጸሎትን ሕብረትን ብቓልን ክውን ክኸውን ትተግህ።
            </p>
          </div>
        </div>
      </div>
    </div>    
  )
}

export default TarikBetekrstyanDetails